// Tuition reimbursement step labels for the stepper component
export const tuitionSteps = [
  "Employee Information",
  "Employment Information",
  "Primary approver information",
  "School/vendor/company information",
  "Class Information",
  "Comments",
  "Participants Conditions",
  "Application submitted",
];

export default tuitionSteps;
